const data: any[] = [
    [
        {
			id: 0,
			title: "经济金融",
			desc: "一揽子增量政策出台后企业感受如何？对打好政策“组合拳”有何期待？对稳住楼市股市，防范化解重点领域风险和外部冲击有何高见？关于财政货币政策、全国统一大市场、宏观政策取向一致性……欢迎来建言。",
		},
		{
			id: 1,
			title: "扩大内需",
			desc: "消费品以旧换新了吗？对购买手机、智能家电、智能网联新能源汽车等，希望有何支持？你所在企业更新设备了吗？怎样壮大数字、绿色、智能等消费新热点，释放情绪消费、“谷子经济”等发展潜力？关于扩大提振消费、提高投资效益、支持“两重”项目……欢迎来建言。",
		},
        {
			id: 2,
			title: "现代化产业体系",
			desc: "如何统筹好培育新动能、更新旧动能的关系，更好发展新质生产力？关于经济高质量发展，实体经济、数字经济、新型工业化、平台经济、低空经济、“人工智能+”、未来产业、耐心资本……欢迎来建言",
		},
		{
			id: 3,
			title: "教育、科技和人才",
			desc: "孩子入园入学升学遇到哪些困难？如何推动义务教育优质均衡发展、推进优质本科扩容？如何加强职业教育和技能人才培养？关于科技企业发展、统筹推进教育科技人才体制机制一体改革……欢迎来建言。",
		},
    ],

    [
        {
			id: 4,
			title: "营商环境",
			desc: "你对公司开办与注销、融资支持、清偿拖欠企业账款、招商引资等方面，有何感受？是否遇到过乱收费、乱罚款等趋利性执法问题？如何营造市场化、法治化、国际化一流营商环境？欢迎来建言。",
		},
        {
			id: 5,
			title: "对外开放",
			desc: "外籍来华人员和港澳台同胞工作生活有哪些不便？外企在华经营情况如何？外贸生意怎样？出口转内销是否遇困难，如何助企开拓市场？如何扩大自主开放、单边开放？怎样更好吸引和利用外资？关于自贸试验区和海南自由贸易港、“一带一路”建设……欢迎来建言。",
		},
		{
			id: 6,
			title: "城乡融合",
			desc: "从农村搬到城镇生活后，居住、落户、子女教育、医疗、养老、就业等情况如何？需完善哪些配套政策？关于深化土地制度改革、耕地占补平衡、种粮积极性、农民增收、现代化都市圈、县域经济……欢迎来建言。",
		},
		{
			id: 7,
			title: "区域战略",
			desc: "你对西部大开发、东北全面振兴、中部地区加快崛起、东部地区加快推进现代化有何高见？关于京津冀、长三角、粤港澳大湾区、长江经济带发展、黄河流域生态保护和高质量发展、雄安新区……欢迎来建言。",
		},
    ],
    [
		{
			id: 8,
			title: "绿色转型",
			desc: "如何深入推进蓝天、碧水、净土保卫战？对绿色低碳产业发展、固体废物综合治理、全国碳市场建设等有何高见？关于协同推进降碳减污扩绿增长、建设“沙戈荒”新能源基地、生物多样性保护……欢迎来建言。",
		},
		{
			id: 9,
			title: "社会保障",
			desc: "你对多层次多支柱养老保险体系，年金、个人养老金等制度，健全社会保障体系等，有何建议？<br/>对租购并举的住房制度、保障性住房、城中村和危旧房改造等有何建议？你心中的好房子什么样？你认为如何建设好房子？欢迎来建言。",
		},
		{
			id: 10,
			title: "就业",
			desc: "你和身边亲友对就业感受如何？法定退休年龄变化，对你的工作和职业规划有何影响？企业对吸纳就业补贴等政策感受如何？关于优化创业促进就业政策环境、灵活就业和新就业形态劳动者权益保障……欢迎来建言。",
		},
		{
			id: 11,
			title: "医疗健康",
			desc: "你和家人是否有看病难、看病贵、看病远等问题？对完善城乡居民医保有何建议？关于药品集中带量采购、药品供应保障、中医药、创新药、分级诊疗、乡村医生、社区医院、医药卫生体制改革……欢迎来建言。",
		},
    ],
    [
		{
			id: 12,
			title: "人口发展支持和服务",
			desc: "你或身边亲友赡养老人有哪些困难？对银发经济、普惠养老服务、补齐农村养老短板等有何建议？关于孩子的生育养育教育成本、生育休假和补贴、普惠育幼服务体系……欢迎来建言。",
		},
		{
			id: 13,
			title: "收入分配",
			desc: "如何提高劳动报酬在初次分配中的比重？如何更好构建初次分配、再分配、第三次分配协调配套的制度体系？关于完善收入分配制度、推动中低收入群体增收减负......欢迎来建言。",
		},
        {
			id: 14,
			title: "提升行政效能",
			desc: "你体验过“高效办成一件事”吗？政务服务还有哪些可以再加把劲？如果你在基层工作，要拼经济促发展、干事创业，需用好哪些实招？关于为基层松绑减负、深入推进依法行政、抓好安全生产、协同推进政策实施和预期引导……欢迎来建言。",
		},
		{
			id: 15,
			title: "文化和体育",
			desc: "最近去过公共图书馆、博物馆、电影院、剧院吗？如何更好促进文化旅游业发展？最近是否体验过冰雪运动？对办好体育赛事活动、加强青少年体育工作、建设体育强国，有何高招？欢迎来建言。",
		},
    ],
    [
        {
			id: 16,
			title: "其他",
			desc: "你希望看到一份怎样的《政府工作报告》？对报告的篇幅、结构、文风等方面有什么建议？<br/>除此之外，对政府工作还有什么想说的？<br/>贴心小提示：选择对应分类填写，建言更易被采纳哦！",
		}, 
    ]
];

let types: any[] = [];

function getTypes() {
    types.push("全部");
    for (let i = 0; i < data.length; i++) {
        let item = data[i];
        for (let j = 0; j < item.length; j++) {
            let child = item[j];
            types.push(child.title);
        }
    }
}
(function () {
    if (types.length == 0) {
        getTypes();
    }
})();

export { data, types };
